export { SafityInformation as SafityInformationSection } from './safity-information/safity-information';
export { HelpForHealing as HelpForHealingSection } from './help-for-healing/help-for-healing';
export { ApligrafSafetyInformation as ApligrafSafetyInformationSection } from './apligraf-safety-information/apligraf-safety-information';
